module.exports = __webpack_public_path__ + "img/icone-instagram.38094387.svg";